export function marqueeSection() {
    const dataFormat = 'LT';
    $('#houston').addClass("houston");
    $('#losAngeles').addClass("losAngeles");
    $('#newYork').addClass("newYork");
    $('#london').addClass("london");
    $('#paris').addClass("paris");
    $('#sydney').addClass("sydney");
    $('#seoul').addClass("seoul");

    const slickOptions = {
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 30000,
        cssEase: 'linear'
    }
    $('.marquee-slider').each(function (index, el) {
        let items = $(el).find(".marquee-slider-item").clone();
        $(el).append(items);
        items = $(el).find(".marquee-slider-item").clone();
        $(el).append(items);
        $(el).slick(slickOptions)
    });
    $('.marquee-slider.rtl').slick('slickSetOption', 'rtl', true, true);

    let onLoadWidth = window.innerWidth;
    $(window).on('resize', function (event) {
        let onResizeWidth = window.innerWidth;
        if (onLoadWidth != onResizeWidth) {
            setTimeout(function () {
                $('.marquee-slider').each(function (index, el) {
                    $(el).slick('unslick');
                });
                $('.marquee-slider').each(function (index, el) {
                    $(el).slick(slickOptions)
                });
                $('.marquee-slider.rtl').slick('slickSetOption', 'rtl', true, true);
            }, 200);
        }
    });
    timeZone();

    function timeZone() {
        let houston = moment().tz("America/Chicago").format(dataFormat);
        let losAngeles = moment().tz("America/Los_Angeles").format(dataFormat);
        let newYork = moment().tz("America/New_York").format(dataFormat);
        let london = moment().tz("Europe/London").format(dataFormat);
        let paris = moment().tz("Europe/Paris").format(dataFormat);
        let sydney = moment().tz("Australia/Sydney").format(dataFormat);
        let seoul = moment().tz("Asia/Tokyo").format(dataFormat);

        $('.houston').html(houston);
        $('.losAngeles').html(losAngeles);
        $('.newYork').html(newYork);
        $('.london').html(london);
        $('.paris').html(paris);
        $('.sydney').html(sydney);
        $('.seoul').html(seoul);
        setTimeout(function () {
            timeZone();
        }, 60000);
    }

}


// WEBPACK FOOTER //
// ./assets/js/modules/marquee-section.js